import { render, staticRenderFns } from "./contact-details-optimised.vue?vue&type=template&id=b87013f4&scoped=true"
import script from "./contact-details-optimised.vue?vue&type=script&lang=js"
export * from "./contact-details-optimised.vue?vue&type=script&lang=js"
import style0 from "./contact-details-optimised.vue?vue&type=style&index=0&id=b87013f4&prod&lang=scss&scoped=true"
import style1 from "./contact-details-optimised.vue?vue&type=style&index=1&id=b87013f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87013f4",
  null
  
)

export default component.exports